// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/collapse-item.css
// module id = XPMo
// module chunks = 4